/**
 * Resolves a file name that does not collide with any already-taken name, mimicking macOS:
 * `Test.pdf` → `Test (1).pdf` → `Test (2).pdf`, filling the lowest available gap.
 *
 * Collisions are matched case-insensitively; the original casing of `desiredName` is preserved
 * in the returned value.
 *
 * @param desiredName    The name the user is trying to use (e.g. `Test.pdf`).
 * @param takenNamesLower A set of already-taken names, each lower-cased by the caller.
 */
export const getUniqueFileName = (desiredName, takenNamesLower) => {
    const isTaken = (name) => takenNamesLower.has(name.toLowerCase());
    if (!isTaken(desiredName)) {
        return desiredName;
    }
    const lastDot = desiredName.lastIndexOf('.');
    // A leading dot (lastDot === 0) or a trailing dot (lastDot at the final position) is not a real
    // extension, so the numbering suffix is appended at the end rather than split around the dot.
    const hasExtension = lastDot > 0 && lastDot < desiredName.length - 1;
    const base = hasExtension ? desiredName.slice(0, lastDot) : desiredName;
    const extension = hasExtension ? desiredName.slice(lastDot) : '';
    for (let counter = 1;; counter += 1) {
        const candidate = `${base} (${counter})${extension}`;
        if (!isTaken(candidate)) {
            return candidate;
        }
    }
};
